import RcVidPlayerLight from './RcVidPlayerLight';
import './App.css';

const AppRcVidPlayerLight = "RcVidPlayerLight";
const urlParameter = paramName => ( new URLSearchParams( window.location.search )).get( paramName );

function App() {
  const privacyPolicy = urlParameter("privacypolicy");

  if (urlParameter("app") === AppRcVidPlayerLight) {
    var version = urlParameter("ver");
    return RcVidPlayerLight(version, privacyPolicy);
  }

  return (
    <div className="App">
      <p>アプリケーションの指定が不明です。</p>
      <a href='https://www.ryujincomputing.co.jp/'>龍神コンピューティングのトップページへ</a>
    </div>  
  );
}

export default App;